// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "application." + "8f013cbeeb9014b8b9f1" + ".css";
};